import { ErrorCodes, isApiError } from '@/api/errors';

export function isAccountNotFound(error: unknown): boolean {
  return isApiError(error) && error.code === ErrorCodes.ACCOUNT_NOT_FOUND;
}
